module.exports = require("tippy.js");